/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable default-param-last */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import {
  FilterContainer,
  DisplayCards,
  DashboardCard,
  BarChartContainer,
  PieChartContainer,
  DualChartContainer,
  PieChartCardContainer,
  PieChartCard,
  PieChartInnerCardText,
  PieChartInnerCardAmmount,
  CircularProgressBarContainer,
  PieChartInnerCardContainer,
} from "./HomeStyles";
import GenericSelectTag from "../../components/Layout/SelectTag/GenericSelectTag";
import DebitCard from "../../assets/images/DebitCardIcon.svg";
import Upi from "../../assets/images/Upi.svg";
import Cheques from "../../assets/images/Cheques 1.svg";
import Rupee from "../../assets/images/CurrencyRupee.svg";
import Netbanking from "../../assets/images/Net Banking logo 2.svg";
import Wallet from "../../assets/images/Wallet.svg";
import BarChart from "../../components/Layout/DashboardBarChart";
import PieChart from "../../components/Layout/DashboardPieChart";
import Button from "../../components/Layout/Button";
import CircularProgressBar from "../../components/Layout/DashboardCircularProgressBar";
import PaymentGatewayBarChart from "../../components/Layout/DashboardBarChart/PaymentGatewayBarChart";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import OrganizationStructure from "../../components/Layout/OrganizationStructure/OrganizationStructure";
import { SERVICES } from "../../components/Layout/Services";
import { get } from "../../components/Layout/ApiHandler/apihandler";
import AggregatedCard from "./Components/Aggregated/AggregatedCard";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import Loader from "../../components/Loader/Loader";
import { logoutAction } from "../../Config/Redux/actions/authActions";
import NotAuthorized from "../../components/Layout/NotAuthorized";

const currentDate = dayjs();
const dateFrom = currentDate.subtract(3, "months").startOf("month");
const dateTo = currentDate.subtract(1, "months").endOf("month");

const initialFormValues = {
  areaId: null,
  dateFrom,
  dateTo,
};

const colorMap = {
  MD: "#265B83",
  WD: "#F974E4",
  YMD: "#85A626",
  YWD: "#4EB6CD",
};

function Home() {
  const currentDate = moment();
  const [selectedDate, setSelectedDate] = useState(null);
  const SelectedUser = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const TITLE = "Dashboard - BSG ContributionAdmin";

  const formattedDateForCards = currentDate.format("DD/MM/YYYY");
  const formattedMonth = currentDate.format("MMM/YYYY");
  const currentMonth = currentDate.format("MM");

  const financialYearStart =
    moment().month() >= 3
      ? moment().startOf("year").month(3)
      : moment().subtract(1, "years").startOf("year").month(3);
  const financialYearEnd =
    moment().month() >= 3
      ? moment().add(1, "years").startOf("year").month(2).date(31)
      : moment().startOf("year").month(2).date(31);

  const formattedFinancialYearStart = financialYearStart.format(" MMMM/YYYY");
  const formattedFinancialYearEnd = financialYearEnd.format(" MMMM/YYYY");

  const [loading, setLoading] = useState(false);
  const [aggregatedData, setAggregatedData] = useState([]);
  const [dateFrom, setDateFrom] = useState(initialFormValues.dateFrom);
  const [dateTo, setDateTo] = useState(initialFormValues.dateTo);
  const [contData, setContData] = useState([]);
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [divisionTypeData, setDivisionTypeData] = useState([]);
  const [paymentGatewayData, setPaymentGatewayData] = useState([]);
  const [profileData, setProfileData] = useState({});
  const [values, setValues] = useState({
    areaId: initialFormValues.areaId,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });

  const updateOrganizationStructureValues = (updatedValues) => {
    setValues(updatedValues);
  };

  const [selectedType, setSelectedType] = useState("All");
  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  useEffect(() => {
    const firstDateOfCurrentMonth = dayjs()
      .subtract(1, "month")
      .startOf("month");
    const lastDateOfCurrentMonth = dayjs().subtract(1, "month").endOf("month");
    setSelectedDate(firstDateOfCurrentMonth);

    fetchContributionTypeData(firstDateOfCurrentMonth, lastDateOfCurrentMonth);
  }, []);

  const onDateChange = (name, date) => {
    if (name === "dateFrom") {
      setDateFrom(date);
    } else if (name === "dateTo") {
      setDateTo(date);
    }
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  const actualDateFrom = dateFrom.$d;
  const actualDateTo = dateTo.$d;
  const formattedDateFrom = formatDateToYYYYMMDD(actualDateFrom);
  const formattedDateTo = formatDateToYYYYMMDD(actualDateTo);

  const constructQueryParameters = (
    includeDates = true,
    firstDate,
    lastDate,
  ) => {
    const queryParams = [];

    const optionalParams = {
      areaId: values.areaId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      districtId: values.districtId,
    };

    for (const key in optionalParams) {
      if (optionalParams[key] !== null && optionalParams[key] !== undefined) {
        queryParams.push(`${key}=${optionalParams[key]}`);
      }
    }
    if (includeDates) {
      queryParams.push(`from=${formattedDateFrom}`);
      queryParams.push(`to=${formattedDateTo}`);
    }

    if (firstDate && lastDate) {
      queryParams.push(`from=${firstDate}`);
      queryParams.push(`to=${lastDate}`);
    }

    return queryParams.join("&");
  };

  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
        if (
          !data.data?.assignedRoles?.includes("contributionAdmin") &&
          !data.data?.assignedRoles?.includes("contributionDataEntry") &&
          !data.data?.assignedRoles?.includes("contributionOfflineDataEntry")
        ) {
          dispatch(logoutAction());
        }
      }
      if (response.status === 403) {
        dispatch(logoutAction());
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const fetchContributionTypeData = async (
    firstDateOfMonth,
    lastDateOfMonth,
  ) => {
    setLoading(true);
    try {
      const formattedFirstDate = firstDateOfMonth.format("YYYY-MM-DD");
      const formattedLastDate = lastDateOfMonth.format("YYYY-MM-DD");
      if (
        dayjs(formattedFirstDate).isValid() &&
        dayjs(formattedLastDate).isValid()
      ) {
        const url = `${
          SERVICES.GET_MONTHLY_CONTRIBUTION
        }?${constructQueryParameters(
          false,
          formattedFirstDate,
          formattedLastDate,
        )}`;
        const response = await get(url);

        if (response && response.ok) {
          const data = await response.json();
          setContData(data.data);
        } else {
          console.error("Failed to fetch Division Type data");
        }
      } else {
        console.error("Invalid formatted dates. Skipping API call.");
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPaymentTypeData = async () => {
    try {
      const url = `${SERVICES.GET_PAYMENT_TYPE}?${constructQueryParameters()}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setPaymentTypeData(data.data);
      } else {
        console.error("Failed to fetch Payment Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const fetchDivisionTypeData = async () => {
    try {
      const url = `${SERVICES.GET_DIVISION_TYPE}?${constructQueryParameters()}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setDivisionTypeData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const getAggregatedContribution = async () => {
    try {
      const url = `${
        SERVICES.AGGREGATED_CONTRIBUTION
      }?${constructQueryParameters(false)}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setAggregatedData(data.data);
      } else {
        console.error("Something is wrong. Contact support");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const fetchpaymentGatewayData = async () => {
    try {
      const url = `${
        SERVICES.GET_PAYMENT_GATEWAY
      }?${constructQueryParameters()}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setPaymentGatewayData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      const firstDayOfMonth = dayjs(date).startOf("month");
      const lastDayOfMonth = dayjs(date).endOf("month");

      fetchContributionTypeData(firstDayOfMonth, lastDayOfMonth);
    }
  };

  const handleSubmit = async (selectedDate) => {
    setLoading(true);

    try {
      const firstDayOfMonth = dayjs(selectedDate).startOf("month");
      const lastDayOfMonth = dayjs(selectedDate).endOf("month");
      await Promise.all([
        fetchContributionTypeData(firstDayOfMonth, lastDayOfMonth),
        fetchPaymentTypeData(),
        fetchDivisionTypeData(),
        getAggregatedContribution(),
      ]);
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const handleApply = async (selectedDate) => {
    try {
      await Promise.all([
        fetchPaymentTypeData(),
        fetchDivisionTypeData(),
        fetchpaymentGatewayData(),
      ]);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const nameofKeys = Object.keys(aggregatedData)
    .filter((key) => aggregatedData[key] !== null)
    .map((key) => {
      const value = aggregatedData[key];
      if (typeof value === "object") {
        const { sum, frequency, divisionName, ...otherProps } = value;
        return JSON.stringify(otherProps);
      }
      return value;
    });

  const structureName = nameofKeys
    .filter((item) => item !== "{}")
    .filter((item) => !["WD", "MD", "YWD", "YMD", "FD"].includes(item));

  const DualBarChart = ["All", "Payment Gateway"];

  useEffect(() => {
    setLoading(true);
    getAggregatedContribution();
  }, []);

  useEffect(() => {
    setLoading(true);
    handleSubmit({ ...initialFormValues });
    handleApply({ ...initialFormValues });
  }, []);

  useEffect(() => {
    getUserRole();
  }, []);

  // Render content based on user role
  const renderContent = () => {
    if (profileData?.assignedRoles?.includes("contributionAdmin")) {
      return (
        <div style={{ width: "100%", overflowX: "auto" }}>
          <PageSyncCal />
          <FilterContainer>
            <div className="hello-text">
              Hello {SelectedUser.adminData?.fullName} !
            </div>
            <div style={{ display: "flex", gap: "20px" }}>
              <div />
              <div />
            </div>
            <div className="select-tags-container">
              <OrganizationStructure
                onUpdateValues={updateOrganizationStructureValues}
                initialAreaId={initialFormValues.areaId}
              />
              <Button onClick={() => handleSubmit(selectedDate)}>Search</Button>
            </div>
            <div className="structure-text">
              {" "}
              {values !== null &&
              Object.values(values).some((value) => value !== null)
                ? ` Selected Structure: ${structureName.join("/ ")}`
                : "National Level"}
            </div>
          </FilterContainer>
          <DisplayCards>
            <DashboardCard>
              <AggregatedCard
                date={`Today (${formattedDateForCards})`}
                contributionAmount={aggregatedData?.todaySum?.sum}
                contributions={aggregatedData?.todaySum?.frequency}
              />
            </DashboardCard>

            <DashboardCard bgColor="#FAFFE1">
              <AggregatedCard
                date={`Month till Date (${formattedMonth})`}
                dateColor="#93A732"
                AggTextColor="#77891E"
                innerCardsColor="#A3B54B"
                contributionAmount={aggregatedData?.monthlySum?.sum}
                contributions={aggregatedData?.monthlySum?.frequency}
              />
            </DashboardCard>

            {currentMonth !== "4" ? (
              <DashboardCard bgColor="#FFF0EF">
                <AggregatedCard
                  date={`FY (${formattedFinancialYearStart} - ${formattedFinancialYearEnd})`}
                  dateColor="#E37F78"
                  AggTextColor="#D75D55"
                  innerCardsColor="#E88B85"
                  contributionAmount={aggregatedData?.yearlySum?.sum}
                  contributions={aggregatedData?.yearlySum?.frequency}
                />
              </DashboardCard>
            ) : null}
          </DisplayCards>
          <BarChartContainer>
            <BarChart
              contData={contData}
              handleSubmit={handleSubmit}
              handleDateChange={handleDateChange}
              selectedDate={selectedDate}
            />
          </BarChartContainer>
          <OuterContainerStyles marginBottom="24px">
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                padding: "24px",
                alignItems: "center",
              }}
            >
              <BasicDatePicker
                label="Date (From)"
                onChange={(date) => onDateChange("dateFrom", date)}
                value={dateFrom}
              />
              <BasicDatePicker
                label="Date (To)"
                onChange={(date) => onDateChange("dateTo", date)}
                value={dateTo}
              />
              <Button onClick={handleApply} cancel>
                Apply
              </Button>
            </Box>
          </OuterContainerStyles>
          <div style={{ display: "flex" }}>
            <DualChartContainer>
              <GenericSelectTag
                data={DualBarChart}
                onChange={handleTypeChange}
                value="All"
              />
              {selectedType === "All" ? (
                <PieChartContainer>
                  <PieChart paymentTypeData={paymentTypeData} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                      justifyContent: "center",
                      flex: 1,
                    }}
                  >
                    <PieChartCardContainer>
                      <PieChartCard bgColor="linear-gradient(180deg, #F98128 0%, #DA4F23 100%)">
                        <PieChartInnerCardContainer>
                          <img src={DebitCard} alt="/debitCard" />
                          <PieChartInnerCardText>Card</PieChartInnerCardText>
                        </PieChartInnerCardContainer>
                        <PieChartInnerCardAmmount>
                          {paymentTypeData.length > 0
                            ? `₹ ${paymentTypeData[0]?.y.toLocaleString(
                                "en-IN",
                              )}`
                            : "NA"}
                        </PieChartInnerCardAmmount>
                      </PieChartCard>
                      <PieChartCard bgColor="linear-gradient(180deg, #FFCE49 0%, #D09F19 100%)">
                        <PieChartInnerCardContainer>
                          <img src={Upi} alt="/upi" />
                          <PieChartInnerCardText>UPI</PieChartInnerCardText>
                        </PieChartInnerCardContainer>
                        <PieChartInnerCardAmmount>
                          {paymentTypeData.length > 0
                            ? `₹ ${paymentTypeData[3]?.y.toLocaleString(
                                "en-IN",
                              )}`
                            : "NA"}
                        </PieChartInnerCardAmmount>
                      </PieChartCard>
                    </PieChartCardContainer>
                    <PieChartCardContainer>
                      <PieChartCard bgColor="linear-gradient(180deg, #6B94FF 42.19%, #1853EA 100%)">
                        <PieChartInnerCardContainer>
                          <img src={Netbanking} alt="/netBanking" />
                          <PieChartInnerCardText>
                            Net Banking
                          </PieChartInnerCardText>
                        </PieChartInnerCardContainer>
                        <PieChartInnerCardAmmount>
                          {paymentTypeData.length > 0
                            ? `₹ ${paymentTypeData[1]?.y.toLocaleString(
                                "en-IN",
                              )}`
                            : "NA"}
                        </PieChartInnerCardAmmount>
                      </PieChartCard>
                      <PieChartCard bgColor="linear-gradient(180deg, #A08FF4 0%, #5B45B2 100%)">
                        <PieChartInnerCardContainer>
                          <img src={Rupee} alt="/rupee" />
                          <PieChartInnerCardText>Cash</PieChartInnerCardText>
                        </PieChartInnerCardContainer>
                        <PieChartInnerCardAmmount>
                          {paymentTypeData.length > 0
                            ? `₹ ${paymentTypeData[5]?.y.toLocaleString(
                                "en-IN",
                              )}`
                            : "NA"}
                        </PieChartInnerCardAmmount>
                      </PieChartCard>
                    </PieChartCardContainer>
                    <PieChartCardContainer>
                      <PieChartCard bgColor="linear-gradient(270deg, #1E8DA1 49.8%, #2FCAC5 100%)">
                        <PieChartInnerCardContainer>
                          <img src={Wallet} alt="/wallet" />
                          <PieChartInnerCardText>Wallets</PieChartInnerCardText>
                        </PieChartInnerCardContainer>
                        <PieChartInnerCardAmmount>
                          {paymentTypeData.length > 0
                            ? `₹ ${paymentTypeData[2]?.y.toLocaleString(
                                "en-IN",
                              )}`
                            : "NA"}
                        </PieChartInnerCardAmmount>
                      </PieChartCard>
                      <PieChartCard bgColor="linear-gradient(180deg, #FF81EB 4.58%, #C907AB 100%)">
                        <PieChartInnerCardContainer>
                          <img src={Cheques} alt="/cheques" />
                          <PieChartInnerCardText>
                            Cheques/DD
                          </PieChartInnerCardText>
                        </PieChartInnerCardContainer>
                        <PieChartInnerCardAmmount>
                          {paymentTypeData.length > 0
                            ? `₹ ${paymentTypeData[4]?.y.toLocaleString(
                                "en-IN",
                              )}`
                            : "NA"}
                        </PieChartInnerCardAmmount>
                      </PieChartCard>
                    </PieChartCardContainer>
                  </div>
                </PieChartContainer>
              ) : (
                <PaymentGatewayBarChart
                  paymentGatewayData={paymentGatewayData}
                  handleSubmit={handleApply}
                />
              )}
            </DualChartContainer>
            <CircularProgressBarContainer>
              <Typography
                sx={{ fontSize: "20px", fontWeight: 500, color: "#585858" }}
              >
                Division Wise Contribution
              </Typography>
              <Typography
                sx={{ fontSize: "14px", fontWeight: 500, color: "#444444" }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgressBar divisionTypeData={divisionTypeData} />
              </Box>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px 9px",
                }}
              >
                {divisionTypeData?.map((division, index) => {
                  const gapValue = index < 2 ? "20px" : "9px";
                  return (
                    <div
                      key={division.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        borderRadius: "4px",
                        gridColumnGap: gapValue,
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          color: colorMap[division.id],
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                      >
                        {division.name}
                      </p>
                      <p
                        style={{
                          margin: "0",
                          color: "#444",
                          fontSize: "14px",
                          fontWeight: "700",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {division.y.toLocaleString("en-IN")}
                      </p>
                    </div>
                  );
                })}
              </div>
            </CircularProgressBarContainer>
          </div>
          {loading && <Loader />}
        </div>
      );
    }

    if (profileData?.assignedRoles) {
      return <NotAuthorized />;
    }

    return <Loader />;
  };

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      {renderContent()}
    </div>
  );
}

export default Home;
